<template>
    <rkm-area
        background-color="secondary"
        closed
        header-prefix-icon="history"
        no-margin-top
        title="Antecedentes"
        type="box"
    >
        <BoxPaciente :item="item" />
        <BoxFamiliar :item="item" />
    </rkm-area>
</template>

<script>
import BoxFamiliar from './components/familiar/Index'
import BoxPaciente from './components/paciente/Index'

export default {
    components: {
        BoxFamiliar,
        BoxPaciente,
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>